import routeMap from "./route-map.json";

export const SUPPORTED_LANGUAGES = Object.keys(routeMap.home);

const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES[0];

export const LOCALIZED_ROUTE_MAP = routeMap;

const normalizeLanguage = (language) =>
  SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE;

export const normalizePath = (value) => {
  if (!value || value === "/") {
    return "/";
  }

  let path = value.startsWith("/") ? value : `/${value}`;

  if (path.length > 1) {
    path = path.replace(/\/+$/, "");
  }

  return path || "/";
};

export const stripLangFromPath = (path) => {
  const normalized = normalizePath(path);
  const withoutLang = normalized.replace(/^\/(en|sv|de|pl)(?=\/|$)/, "");
  return withoutLang || "/";
};

export const getRouteKeyForPath = (path) => {
  const normalized = normalizePath(path);

  return (
    Object.entries(LOCALIZED_ROUTE_MAP).find(([, mapping]) =>
      Object.values(mapping).map(normalizePath).includes(normalized)
    )?.[0] || null
  );
};

export const buildLocalizedPath = (language, target) => {
  const lang = normalizeLanguage(language);
  const mapping = LOCALIZED_ROUTE_MAP[target];

  if (mapping) {
    const slug = normalizePath(mapping[lang] ?? mapping[DEFAULT_LANGUAGE]);
    return slug === "/" ? `/${lang}/` : `/${lang}${slug}`;
  }

  const normalized = normalizePath(target);
  return normalized === "/" ? `/${lang}/` : `/${lang}${normalized}`;
};

export const translatePathToLanguage = (currentPath, targetLang) => {
  const lang = normalizeLanguage(targetLang);
  const pathWithoutLang = stripLangFromPath(currentPath);
  const key = getRouteKeyForPath(pathWithoutLang);

  if (key) {
    return buildLocalizedPath(lang, key);
  }

  return pathWithoutLang === "/"
    ? `/${lang}/`
    : `/${lang}${pathWithoutLang}`;
};
